import http from '@/utils/http' //引入axios
export const getDept = data => http.get('/user-center/api/dept', {
    params: data
}) //查找部门
export const updataDept = data => http.put('/user-center/api/dept', data) //編輯部门
export const addDept = data => http.post('/user-center/api/dept', data) //添加部门
export const deleteDept = data => http.delete('/user-center/api/dept', {
    params: data
}) //根据id刪除部门
export const findDept = data => http.get('/user-center/api/dept/superior', {
    params: data
}) //查找部门
export const getDeptMachineId = data => http.get('/user-center/api/dept/machine', {
    params: data
}) //查找部门
export const editDeptMachine = data => http.put('/user-center/api/dept/machine', data) //修改部门設備
export const exportDept = data => http.get('/user-center/api/dept/excel', {
    params: data,
    responseType: 'blob'
})
export const getAllMachine = data => http.get('/rvm-center/api/machine/findProjectMachines', {
    params: data
})

export default {
    getDept,
    updataDept,
    addDept,
    deleteDept,
    findDept,
    getDeptMachineId,
    editDeptMachine,
    exportDept,
    getAllMachine
}